module.exports = __webpack_public_path__ + "img/7house06.924dd994.jpg";